import api from "./apiClient";
import Jsona from "jsona";
const dataFormatter = new Jsona();

const API_URL = process.env.VUE_APP_API_BASE_URL + '/api/v2/';

export default {
  async getProfile() {
    const response = await api.get(API_URL + "me");
    return dataFormatter.deserialize(response.data);
  },

  async uploadPic(object) {
    let formData = new FormData();
    formData.append("attachment", object.pic);
    const response = await api.post(
      API_URL + "uploads/users/" + object.id + "/profile-image",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data.url;
  },

  async updateProfile(profile) {
    profile.type = "profile";
    delete profile.links;
    const response = await api.patch(
      API_URL + "me",
      dataFormatter.serialize({ stuff: profile })
    );
    return dataFormatter.deserialize(response.data);
  },

  async updateTipster(tipster) {
    const response = await api.post(API_URL + "updateTipster", tipster);
    if (response.data) {
      return response.data;
    }
  },

  async updateTipsterStripe(data) {
    const response = await api.post(API_URL + "tipster/stripe", data);
    if (response.data) return response.data;
  },

  async testStripe() {
    const response = await api.post(API_URL + "tipster/stripe/test", {});
    if (response.data) return response.data;
  },

  async suscripcionesActivas() {
    const response = await api.get(API_URL + "tipster/suscripciones-activas");
    if (response.data) return response.data;
  },
};
